import { Component, Input, SimpleChanges } from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { CommonModule } from '@angular/common';
import { DocumentRangeService } from 'app/modules/components/document/document-range/document-range.service';
import { DocumentRangeAttributes } from '@albatrosdeveloper/ave-models-package';

@Component({
    selector: 'app-pdf-transport',
    templateUrl: './pdf-transport.component.html',
    styleUrl: "./pdf-transport.component.scss",
    standalone: true,
    imports: [
        CommonModule
    ]
})
export class GuiaRemisionComponent {
    @Input() guiaData: any;
    date: Date;

    constructor(
    ) {
        this.date = new Date();
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.guiaData) {
        }
    }


    get totalLibras(): number {
        if (!this.guiaData?.detail) return 0;

        return this.guiaData.detail.reduce((total, item) => {
            const cantidad = parseFloat(item?.baseQuantity) || 0;
            return total + cantidad;
        }, 0);
    }

    get filasVacias() {
        const actuales = this.guiaData?.detail?.length || 0;
        const totalDeseado = 10;
        return new Array(Math.max(totalDeseado - actuales, 0));
    }

    removeLeadingZeros(value: string | number): string {
        const str = value?.toString();
        return str ? str.replace(/^0+/, '') : '';
      }



    async generarPDF() {
        const element = document.getElementById('guia-remision-container');
        if (!element) return;
        const canvas = await html2canvas(element, {
            scale: 2, // Mejor calidad
            logging: false,
            useCORS: true
        });

        const imgData = canvas.toDataURL('image/png');
        const doc = new jsPDF('p', 'mm', 'a4');
        const imgProps = doc.getImageProperties(imgData);
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        doc.save('guia-remision.pdf');
    }

    async verPDF() {
        if (!this.guiaData) {
            return;
        }
        const element = document.getElementById('guia-remision-container');
        if (!element) return;
        const canvas = await html2canvas(element, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');
        const doc = new jsPDF('p', 'mm', 'a4');
        const imgProps = doc.getImageProperties(imgData);
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        const pdfUrl = doc.output('bloburl');
        window.open(pdfUrl as any, '_blank');
    }
}